<template>
    <div class="product-properties">
        <h3 class="section-title">{{ data.title }}</h3>

        <dl class="list">
            <template
                v-for="(section, index) in data.sections"
                :key="index"
            >
                <dt
                    class="title"
                    role="heading"
                    aria-level="3"
                >
                    {{ section.heading }}:
                </dt>

                <dt class="definition">
                    {{ section.definition }}
                </dt>
            </template>
        </dl>
    </div>
</template>

<script lang="ts">
export type ProductPropertiesSection = {
    heading: string
    definition: string
}

export type ProductPropertiesData = {
    title: string
    sections: ProductPropertiesSection[]
}
</script>

<script setup lang="ts">
defineProps<{
    data: ProductPropertiesData
}>()
</script>

<style lang="scss" scoped>
.product-properties {
    padding: 0 0 20px;

    .section-title {
        color: var(--blue);
        font-size: 1rem;
        font-family: $parcel-font-stack;
        margin: 0 0 20px;
    }

    .list {
        font-size: 0.825rem;
        line-height: 1em;

        .title,
        .definition {
            display: inline;
            font-family: $effra-font-stack;
            text-transform: uppercase;
            letter-spacing: 0.05em;
        }

        .definition {
            &::after {
                content: '';
                display: block;
                height: 7px;
            }
        }
    }
}
</style>
